module.exports = __webpack_public_path__ + "static/media/handphone.1304556b.webp";